module.exports = __webpack_public_path__ + "static/StyreneA-Regular-7f5225bf17e5b94c810ef29acccd31fd.woff";